import React from 'react';
import { Users } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import { usePreregistroCount } from '../hooks/usePreregistroCount';

export const PreregistroCounter = ({ size = 'md', className = '' }) => {
  const { language } = useLanguage();
  const isES = language === 'es';
  const count = usePreregistroCount();
  if (count === null) return null;
  const sm = size === 'sm';
  return (
    <div
      className={`inline-flex items-center gap-2 rounded-full bg-white/[0.07] border border-[#D4AF37]/40 backdrop-blur-md ${sm ? 'px-3 py-1 text-xs' : 'px-4 py-2 text-sm'} ${className}`}
      data-testid="preregistro-counter"
      aria-live="polite"
    >
      <span className="relative flex h-2 w-2">
        <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-emerald-400 opacity-75"></span>
        <span className="relative inline-flex rounded-full h-2 w-2 bg-emerald-400"></span>
      </span>
      <Users className={`${sm ? 'w-3.5 h-3.5' : 'w-4 h-4'} text-[#D4AF37]`} />
      <span className="text-white font-semibold">
        <span className="text-[#D4AF37] font-black tabular-nums" data-testid="preregistro-counter-value">+{count.toLocaleString(isES ? 'es-MX' : 'en-US')}</span>{' '}
        {isES ? 'ya se pre-registraron' : 'already pre-registered'}
      </span>
    </div>
  );
};

export default PreregistroCounter;
